import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntries from "@/pages/home/components/CategoryEntries";
import FeaturedGrid from "@/pages/home/components/FeaturedGrid";
import HotRanking from "@/pages/home/components/HotRanking";
import Collections from "@/pages/home/components/Collections";
import SiteIntro from "@/pages/home/components/SiteIntro";
import { getMediaById } from "@/lib/media";
import type { MediaItem } from "@/mocks/movies";
import { mediaList } from "@/mocks/movies";
import { homeMeta, usePageMeta } from "@/hooks/usePageMeta";

const featuredIds = ["m001", "t001", "m002", "v001"];

export default function Home() {
  usePageMeta(homeMeta);

  const featured = featuredIds
    .map((id) => getMediaById(id))
    .filter((item): item is MediaItem => Boolean(item));

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="w-full flex-1">
        <div className="w-full px-4 pt-7 md:px-8 md:pt-9">
          <div className="flex flex-wrap items-end justify-between gap-3">
            <div>
              <p className="text-[11px] uppercase tracking-[0.3em] text-primary-600">
                蜜桃33 · Movie Library
              </p>
              <h1 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-[32px]">
                今晚，看点好的
              </h1>
            </div>
            <p className="text-xs text-foreground-500">
              电影 · 电视剧 · 综艺
              <span className="mx-2 text-foreground-300">|</span>
              共 {mediaList.length} 部虚构精选资源
            </p>
          </div>
        </div>
        <HeroCarousel items={featured} />
        <CategoryEntries />
        <FeaturedGrid />
        <HotRanking />
        <Collections />
        <SiteIntro />
      </main>
      <SiteFooter />
    </div>
  );
}